import type { AvailableAccounts } from '~/types/auth';

export default defineNuxtRouteMiddleware(async (to) => {
	const skipLoginCheckRoutes = [
		'logout',
		'forgot-password',
		'account-selector',
		'two-factor-authorization',
	];
	if (skipLoginCheckRoutes.includes(to.name as string)) {
		return;
	}

	try {
		const callbackUrl = (to.query.callbackUrl || useCamPortalURL()) as string;
		const applicationCode = (to.query.applicationCode as string | undefined) ?? 'cam'; // Default to CAM
		const wantedAccountCode = to.query.accountCode as string | undefined;
		const res = await $fetch<ValueResponse<LoginStatusResponse>>('/api/auth/status', {
			method: 'POST',
			body: {
				callbackUrl,
				applicationCode,
			},
		});

		useAvailableAccounts().setAccounts({
			accounts: res.value.accounts,
			callbackUrl,
			requiredAccountType: res.value.requiredAccountType,
			needsFullAccount: res.value.needsFullAccount,
			applicationCode,
			wantedAccountCode,
		});

		return navigateTo({
			name: 'account-selector',
			query: to.query.loginErrorType !== undefined || to.query.loginErrorMessage !== undefined
				? {
						loginErrorType: to.query.loginErrorType,
						loginErrorMessage: to.query.loginErrorMessage,
						callbackUrl,
						applicationCode,
					}
				: undefined,
		});
	}
	catch (e) {
		console.warn('User not logged in', e);

		if (to.query.loginRequired === 'false' && to.query.callbackUrl) {
			const url = new URL(to.query.callbackUrl as string);

			// Add unauthenticated flag to the callback URL
			// This tells the app that the user is not authenticated
			url.searchParams.set('unauthenticated', 'true');
			return navigateTo(url.toString(), {
				replace: true,
				external: true,
				redirectCode: 302,
			});
		}
	}
});

interface LoginStatusResponse extends AvailableAccounts {}
